import React from 'react';
import { createPortal } from 'react-dom';

import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { ModelPreview } from '@spazious/dollhouse-engine';
import { Flex, Spinner } from '@spazious/dollhouse-uikit';

export interface DraggableCardOverlayProps {}

export const DraggableCardOverlay: React.FC<DraggableCardOverlayProps> = () => {
  const ctx = useDndContext();

  const { url } = ctx.active?.data.current ?? {};

  return url
    ? createPortal(
        <DragOverlay
          style={{
            opacity: ctx.collisions?.length ? 0.0 : 1,
          }}
        >
          <Flex height="200px" width="200px">
            <ModelPreview fallback={<Spinner />} name="" type="image" url={url} />
          </Flex>
        </DragOverlay>,
        document.body as Element
      )
    : null;
};
